import BaseClass from "../BaseClass"

import {TempusDominus, loadLocale, locale, DateTime,DefaultEnLocalization} from '@eonasdan/tempus-dominus';
import {localization, de} from "@eonasdan/tempus-dominus/dist/locales/de";


export default class DateTimePickerHandler extends BaseClass {

    constructor(element) {
        super(element);
        this.opened = false;
        this.$input = null;
        this.$dateView = null;
        this.$timeView = null;
        this.$timeStampInput = null;
        this.$timeStampInputEnd = null;
        this.viewDate = new Date();
        this.minDate = null;
        this.maxDate = null;
        this.dateRange = false;
        this.hideTime = false;
        this.stepping = 1;

        let mySelf = this;
        let timeStamp = 0;

        let $dateView = this.$element.find('[data-type="date_view"]');
        let $timeView = this.$element.find('[data-type="time_view"]');
        let $timeStampInput = this.$element.find('[data-type="timestamp"]');
        let $timeStampInputEnd = this.$element.find('[data-type="timestamp_end"]');

        if ($dateView != undefined) {
            this.$dateView = $dateView;

            this.$dateView.on('click', function () {
                mySelf.$element.find('.calendartrigger').parent().trigger('click');
            });
        }
        if ($timeView != undefined) {
            this.$timeView = $timeView;

            this.$timeView.on('click', function () {
                mySelf.$element.find('.clocktrigger').parent().trigger('click');
            });
        }
        if ($timeStampInput != undefined) {
            this.$timeStampInput = $timeStampInput;
            timeStamp = this.$timeStampInput.attr('data-value');

            if (timeStamp > 0) {
                this.viewDate = new Date(parseInt(timeStamp));
            }
        }

        if ($timeStampInputEnd != undefined) {
            this.$timeStampInputEnd = $timeStampInput;
        }

        let pickerDomElement = document.getElementById('datetimepicker1');

        if (pickerDomElement != undefined) {

            let currentLocalization = localization;

            if (this.currentLanguage == 'de') {
                currentLocalization.locale = "de-DE";
            } else {
                DefaultEnLocalization.locale = "en-EN";
                currentLocalization = DefaultEnLocalization;
            }

            const minDate = $(pickerDomElement).attr('data-min-date');
            if (minDate != undefined && minDate.length > 0) {
                this.minDate = new Date(minDate);
            }

            const maxDate = $(pickerDomElement).attr('data-max-date');
            if (maxDate != undefined && maxDate.length > 0) {
                this.maxDate = new Date(maxDate);
            }

            const resctrictions = {};
            if (this.minDate != null) {
                resctrictions['minDate'] = this.minDate;
            }

            if (this.maxDate != null) {
                resctrictions['maxDate'] = this.maxDate;
            }

            const dateRange = $(pickerDomElement).attr('data-daterange');
            if (dateRange != undefined && dateRange == '1') {
                this.dateRange = true;
            }

            const hideTime = $(pickerDomElement).attr('data-hide-time');

            if (hideTime != undefined && hideTime == '1') {
                this.hideTime = true;
            }
            const components = {
                calendar: true,
                date: true,
                month: true,
                year: true,
                decades: true,
                clock: true,
                hours: true,
                minutes: true
            };
            if (this.hideTime) {
                components['clock'] = false;
                components['hours'] = false;
                components['minutes'] = false;
            }

            const stepping = $(pickerDomElement).attr('data-stepping');
            if (stepping != undefined && stepping > 0) {
                this.stepping = stepping;
            }

            const picker = new TempusDominus(pickerDomElement, {
                localization: currentLocalization,
                restrictions: resctrictions,
                display: {
                    inline: true,
                    icons: {
                        type: 'icons',
                        time: 'fa-solid fa-clock eventstop clocktrigger',
                        date: 'fa-solid fa-calendar eventstop calendartrigger',
                        up: 'fa-solid fa-arrow-up',
                        down: 'fa-solid fa-arrow-down',
                        previous: 'fa-solid fa-chevron-left',
                        next: 'fa-solid fa-chevron-right',
                        today: 'fa-solid fa-calendar-days',
                        clear: 'fa-solid fa-trash',
                        close: 'fa-solid fa-xmark'
                    },
                    buttons: {
                        today: true
                    },
                    components: components
                },
                stepping: this.stepping,
                dateRange: this.dateRange
            });

            pickerDomElement.addEventListener('change.td', function (event) {
                if (mySelf.$dateView != null) {
                    const options = {weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'};
                    let dateString = picker.viewDate.toLocaleDateString(currentLocalization.locale, options);

                    if (picker.dates.picked.length == 2) {
                        let startDate = picker.dates.picked[0].toLocaleDateString(currentLocalization.locale, options);
                        let endDate = picker.dates.picked[1].toLocaleDateString(currentLocalization.locale, options);
                        dateString = startDate + ' - ' + endDate;
                    }
                    mySelf.$dateView.html(dateString);
                }
                if (mySelf.$dateView != null) {
                    const options = {hour: "2-digit", minute: "2-digit"};
                    let timeString = picker.viewDate.toLocaleTimeString(currentLocalization.locale, options);
                    mySelf.$timeView.html(timeString);
                }

                if (mySelf.dateRange && mySelf.$timeStampInputEnd != undefined && picker.dates.picked.length == 2) {
                    $timeStampInput.val(picker.dates.picked[0].valueOf());
                    $timeStampInputEnd.val(picker.dates.picked[1].valueOf());
                } else {
                    $timeStampInput.val(picker.viewDate.valueOf());
                }
            });

            pickerDomElement.addEventListener('update.td', function (event) {
                $('.eventstop').on('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    $(this).parent().trigger("click");
                });
            });

            if (timeStamp > 0) {
                setTimeout(function () {
                    mySelf.$timeStampInput.val(timeStamp);
                }, 500);
            }

            const parsedDate = picker.dates.parseInput(mySelf.viewDate);
            picker.dates.setValue(parsedDate);

        }

        $('.eventstop').on('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).parent().trigger("click");
        });

    }
}